/**
 * Created by andrey on 31.07.2023
 */

const FogBalloon = function (tile, block) { 
    this.tile = tile;
    this.block = block;

    this.shown = true;
    this.state = this.tile.state;

    this.onHide = function () {};
    this.onShow = function () {};

    this.hide();
};

FogBalloon.prototype.updateState = function (state, silent) {
    if (this.state === state) {
        return;
    }
    this.state = state;

    if (this.state === FogBlock.CANOPEN) {
        this.show(silent);
    }
};

FogBalloon.prototype.show = function (silent) {
    if (!this.shown && this.state === FogBlock.CANOPEN) {
        this.shown = true;
        this.onShow(silent);
    }
};

FogBalloon.prototype.hide = function (silent) {
    if (this.shown) {
        this.shown = false;
        this.onHide(silent);
    }
};

FogBalloon.ChoosePosition = function (positions, head) {
    const map = Map2d.currentMap;

    const extendedDirs = Object.values(Iso);
    const dirs = ISO_NEIGHBORS;
    let balloonCell;

    positions.forEach((position) => {
        dirs.forEach((direction) => {
            const cell = cc.p(position.x + direction.x, position.y + direction.y);

            if (map.getValue(Map2d.LAYER_WATER, cell.x, cell.y) !== Map2d.TILE_WATER) {
                return;
            }

            let countBadDirections = 0;

            extendedDirs.forEach((currDir) => {
                let neighborWaterCells = 0;
                for (let step = 1; step <= 2; step++) {
                    if (map.getValue(Map2d.LAYER_WATER, cell.x + currDir.x * step, cell.y + currDir.y * step) !== Map2d.TILE_WATER) {
                        neighborWaterCells++;
                    }
                }

                if (neighborWaterCells < 2) {
                    countBadDirections++;
                }
            });

            if (countBadDirections > 3 || head && cc.getDistanceChebyshev(cell, head) <= 1) {
                return;
            }
            if (!balloonCell || cell.y < balloonCell.y) {
                balloonCell = cell;
                return;
            }
            if (Math.abs(cell.y - balloonCell.y) <= 1) {
                if (cell.x < Map2d.currentMap.width / 2 && cell.x < balloonCell.x) {
                    balloonCell = cell;
                }
                if (cell.x >= Map2d.currentMap.width / 2 && cell.x > balloonCell.x) {
                    balloonCell = cell;
                }
            }
        });
    });

    return balloonCell || positions[0];
};